import axios from 'axios';

import { getTokenTMOV, startRefreshToken } from '../security/authService';

const apiATS = axios.create({
  baseURL: process.env.REACT_APP_ATS_API_URL,
});

apiATS.interceptors.request.use(async config => {
  const token = getTokenTMOV();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiATS.interceptors.response.use(
  response => response,
  reject => {
    const originalRequest = reject.config;
    if (
      reject.response?.status === 401 &&
      !originalRequest._retry &&
      window.location.hash !== '#/'
    ) {
      return startRefreshToken(originalRequest);
    }
    return Promise.reject(reject);
  }
);

export default apiATS;
